import axios from 'axios';
import Cookie from '../../../services/cookie';
import _ from 'lodash'

// Keep cookie helpers local so qryFunc does not import src/util (circular: util -> DutyItem -> qryFunc).
const getCookie = (cname) => {
  if (!cname) cname = window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN || 'kxBrokerToken';
  return Cookie.get(cname) || '';
};

const logout = () => {
  Cookie.del(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN);
  Cookie.del('kxBrokerToken');
  Cookie.del('kxEntrySummaryToken');
  window.location.reload(true);
};

axios.defaults.baseURL = window.BASE_URL;
axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['kxToken'] = getCookie(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN) || getCookie('kxBrokerToken') || getCookie('kxSupervisorToken');
axios.defaults.method = 'post';

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  // Do something with response data
  return response;
}, function (error) {
  // Do something with response error
  const msg = _.get(error, 'response.data.msg', null)
  if (msg === 'Expired Token' || msg === 'Event not allowed without valid token') {
    // Send user to login URL
    if(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN == 'kxEngineBrokerToken'){
      setTimeout(()=>{
        window.location = '/'+window.location.search
      },3000)

    } else {
      logout();
      window.location = '/'+window.location.search
    }
  }
  return Promise.reject(error);
});

const custom = (config = {}) => {
  let url = window.BASE_URL || config.url || axios.defaults.baseURL;
  // if(url.indexOf("?")!= -1){
  //   url = url+"&axd="+config.data.eventType + '&timeout=60000'
  // }else{
  //   url = url+"?axd="+config.data.eventType + '&timeout=60000'
  // }
  if(url.indexOf("?")!= -1){
    url = url+"&axd="+config.data.eventType
  }else{
    url = url+"?axd="+config.data.eventType
  }
  config.url = url;
  return axios(config);
}

const fileUpload = (data, config = {}, shipId) => {
  axios.defaults.baseURL = `${window._env_.REACT_APP_MEDIA_URL}/${shipId}`;
  return axios(data, config);
}

const addDoc = (data, config = {}) => {
  axios.defaults.baseURL = `${window.BASE_URL}?timeout=10000`;
  return axios(data, config);
}

const all = (requestArray) => {
  return axios.all(requestArray)
}
const post = data => {
  let config = {}
  config.data = data
  return axios(config)
}
const get = (url = '', data = '', config = {}) => {
  config.params = data;
  config.method = "get";
  return axios.request({
    method: "get",
    url: url,
    crossDomain: true
  })
  
}

const put = (url = '', data = '', config = {}) => {
  return axios.put(url, data, config)
}

const del = (url = '', config = {}) => {
  return axios.delete(url, config)
}

const HttpClient = {
  custom,
  post,
  get,
  put,
  delete: del,
  all,
  fileUpload,
  addDoc,
}

export { HttpClient }
